var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-wrapper"},[_c('div',{staticClass:"popup-body-wrapper"},[_c('div',{staticClass:"popup-body",style:({'max-width': _vm.maxWidth +'px'})},[_vm._t("default")],2),_c('div',{staticClass:"backdrop",on:{"click":function($event){return _vm.$emit('close')}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }